<app-header [logoImg]="logoImg" stickyLogoImg="../../../assets/imgs/logo/se2in_logo_textwhite.png" [stickyHeaderWhite]="true"></app-header>

<app-auth [loginForm]="loginForm" (commit)="registration()">
        <div header class="button-text">
            {{ 'LOGIN_REGISTRATION' | translate }}
        </div>
        <div body>
            <hr class="item-line-between">
            <span class="form-group-center">
                <p>{{'ACCOUNT_EXISTS' | translate}}<a class="ms-2" href="/login"> {{ 'LOGIN_PAGE_TITLE' | translate }}</a></p>
            </span>
        </div>
</app-auth>
<app-footer></app-footer>